import React, { FC } from 'react';

import { EvChipItem, EvChips } from '@evinced-private/ui-common';

import { LABEL_MANAGEMENT_VALUES_CELL_DAID } from 'data-automation-ids/LabelManagementAutomationIds';

import { VALUES_CELL_MAX_VISIBLE } from '../LabelsTable.constants';

type ValuesCellProps = {
	values: string[];
	onShowMore?: () => void;
};

export const ValuesCell: FC<ValuesCellProps> = ({ values, onShowMore }) => {
	const chips: EvChipItem[] = values.map((v) => ({ id: v, label: v }));

	return (
		<EvChips
			chips={chips}
			maxVisible={VALUES_CELL_MAX_VISIBLE}
			showMoreProps={onShowMore ? { onClick: onShowMore } : undefined}
			dataAutomationId={LABEL_MANAGEMENT_VALUES_CELL_DAID}
		/>
	);
};
